import React from 'react'
import Checkbox from '../../../../components/Form/Inputs/Checkbox'
import { getMessage } from '../../../../lib/translator'

import './endpointMatrix.css'

const ALL_METHODS = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']

// allowedMethods can arrive as an array (from the catalog / edit prefill) or a map {GET:true}
// (a freshly-selected Searchable option). Normalise to an array.
function allowedList(endpoint) {
  const allowed = endpoint && endpoint.allowedMethods
  if (Array.isArray(allowed)) {
    return allowed
  }
  return Object.keys(allowed || {}).filter((m) => allowed[m])
}

// Presentational: the parent RoleForm owns endpoint selection + method state.
export default function EndpointMatrix({
  endpoints = [],
  methods = {},
  onToggle,
}) {
  if (!endpoints.length) {
    return (
      <div className="endpoint-matrix-empty">
        {getMessage('role.form.noEndpoints')}
      </div>
    )
  }
  return (
    <div className="endpoint-matrix">
      <div className="endpoint-matrix-row endpoint-matrix-head">
        <div className="endpoint-matrix-url">{getMessage('endpoint.url')}</div>
        <div className="endpoint-matrix-methods">
          {getMessage('role.form.methods')}
        </div>
      </div>
      {endpoints.map((endpoint) => {
        const allowed = allowedList(endpoint)
        const selected = methods[endpoint.id] || []
        const options = allowed.length ? allowed : ALL_METHODS
        return (
          <div className="endpoint-matrix-row" key={endpoint.id}>
            <div className="endpoint-matrix-url">{endpoint.url}</div>
            <div className="endpoint-matrix-methods">
              {options.map((method) => (
                <span className="endpoint-matrix-method" key={method}>
                  <Checkbox
                    controlled
                    name={`ep-${endpoint.id}-${method}`}
                    value={selected.indexOf(method) > -1}
                    onChange={(checked) =>
                      onToggle(endpoint.id, method, checked)
                    }
                    inlineLabel={method}
                  />
                </span>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
